module.exports = __webpack_public_path__ + "static/img/industry03.d9514ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/industry03.png
// module id = Felr
// module chunks = 0